//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0,
            surveyDialogVisible: false,
            nickname: '',
            avatar: '',
            nicknameOptions: [
                this.$lang.get('onboarding.names.astronaut'),
                this.$lang.get('onboarding.names.astronautin'),
                this.$lang.get('onboarding.names.bibi'),
                this.$lang.get('onboarding.names.blitz'),
                this.$lang.get('onboarding.names.blumchen'),
                this.$lang.get('onboarding.names.cosma'),
                this.$lang.get('onboarding.names.flash'),
                this.$lang.get('onboarding.names.greg'),
                this.$lang.get('onboarding.names.joker'),
                this.$lang.get('onboarding.names.leni'),
                this.$lang.get('onboarding.names.lotta'),
                this.$lang.get('onboarding.names.maxi'),
                this.$lang.get('onboarding.names.nauti'),
                this.$lang.get('onboarding.names.niki'),
                this.$lang.get('onboarding.names.petronella'),
                this.$lang.get('onboarding.names.pirat'),
                this.$lang.get('onboarding.names.piratin'),
                this.$lang.get('onboarding.names.prinz'),
                this.$lang.get('onboarding.names.prinzessin'),
                this.$lang.get('onboarding.names.sonnenschein'),
                this.$lang.get('onboarding.names.star'),
                this.$lang.get('onboarding.names.superman'),
                this.$lang.get('onboarding.names.superwoman')
            ]
        };
    },

    methods: {
        validateNickname () {
            if (this.nickname.trim() === '') {
                this.$notify.error({
                    title: this.$lang.get('onboarding.validation.name')
                });

                return;
            }

            if (this.$authUser.cannot('classes.manage') && !this.$authUser.is_testuser) {
                this.surveyDialogVisible = true;
            } else {
                this.index++;
            }
        },
        validateAvatar () {
            if (this.avatar.trim() === '') {
                this.$notify.error({
                    title: this.$lang.get('onboarding.validation.figure')
                });

                return;
            }

            this.index++;
        },
        store () {
            axios.put('onboarding', {
                nickname: this.nickname,
                avatar: this.avatar,
                consent_parent: true,
                consent_kid: true
            }).then(response => {
                this.$store.commit('storeGameData', response.data.data);
                this.$router.push({ name: 'cockpit' });
            }).catch(error => {
                console.log(error);
            });
        }
    }
};
